import { theme } from "../../../design/theme";

export interface PageColourOptions {
  background: string;
  text: string;
  text_secondary: string;
  link_text: string;
  footnote_text: string;
}

export const pageColourOptions = {
  green: {
    background: theme.colours.other.greenBackground,
    text: theme.colours.accent.dark._50,
    text_secondary: theme.colours.uIGrey.mid.dark_20,
    link_text: theme.colours.primary.mid.dark10,
    footnote_text: "#57655A",
  },
  white: {
    background: theme.colours.uIGrey.light._10,
    text: theme.colours.uIGrey.dark._10,
    text_secondary: theme.colours.uIGrey.mid.dark_10,
    link_text: theme.colours.primary.mid.mid,
    footnote_text: theme.colours.accent.mid.dark15,
  },
  cream: {
    background: "#FBEFD8",
    text: theme.colours.accent.dark._50,
    text_secondary: theme.colours.uIGrey.mid.dark_20,
    link_text: theme.colours.primary.mid.dark10,
    footnote_text: "#6E695F",
  },
  black: {
    background: theme.colours.uIGrey.dark._70,
    text: theme.colours.uIGrey.light._15,
    text_secondary: theme.colours.uIGrey.light._30,
    link_text: theme.colours.primary.light._50,
    footnote_text: theme.colours.accent.light._60,
  },
};

export const fontMap = {
  inter: {
    fontFamily: `"Inter", sans-serif`,
    displayName: "Inter",
    sansSerif: true,
    lineHeightMultiplier: 1.5,
    paragraphSpacingMultiplier: 1,
  },
  andika: {
    fontFamily: `"Andika", sans-serif`,
    displayName: "Andika",
    sansSerif: true,
    lineHeightMultiplier: 1.5,
    paragraphSpacingMultiplier: 1,
  },
  atkinsonHyperlegible: {
    fontFamily: `"Atkinson Hyperlegible", sans-serif`,
    displayName: "Atkinson Hyperlegible",
    sansSerif: true,
    lineHeightMultiplier: 1.5,
    paragraphSpacingMultiplier: 1,
  },
  opendyslexic: {
    fontFamily: `"OpenDyslexic", sans-serif`,
    displayName: "OpenDyslexic",
    sansSerif: true,
    lineHeightMultiplier: 1.8,
    paragraphSpacingMultiplier: 1,
  },
  vollkorn: {
    fontFamily: `"Vollkorn", serif`,
    displayName: "Vollkorn",
    sansSerif: false,
    lineHeightMultiplier: 1.25,
    paragraphSpacingMultiplier: 0.75,
  },
  bitter: {
    fontFamily: `"Bitter", serif`,
    displayName: "Bitter",
    sansSerif: false,
    lineHeightMultiplier: 1.35,
    paragraphSpacingMultiplier: 0.5,
  },
  charisSIL: {
    fontFamily: `"CharisSIL", serif`,
    displayName: "Charis SIL",
    sansSerif: false,
    lineHeightMultiplier: 1.4,
    paragraphSpacingMultiplier: 0.75,
  },
};

export const fontOptionsSansSerif = Object.entries(fontMap)
  .filter((font) => font[1].sansSerif)
  .map(([key]) => key as keyof typeof fontMap);
export const fontOptionsSerif = Object.entries(fontMap)
  .filter((font) => !font[1].sansSerif)
  .map(([key]) => key as keyof typeof fontMap);
